import AbstractProvidedClass from "../../shared/AbstractProvidedClass";
import ActionFactory from "./ActionFactory";
import { ACTION_MAP } from "./ActionHelper";

export default class ActionHandler extends AbstractProvidedClass {
    pastActions = [];
    futureActions = [];
    currentAction = null;

    constructor(provider) {
        super(provider);

        this.factory = new ActionFactory(provider);
    }

    current(action) {
        if (this.currentAction) {
            this.currentAction.finish();
        }
        this.currentAction = action;
        return action;
    }

    finish() {
        if (this.currentAction) {
            this.pastActions.push(this.currentAction);
            this.futureActions = [];
            this.currentAction = null;
            this.changesMade();
            this.enableUndoButton();
            this.disableRedoButton();
        }
    }

    discard() {
        this.currentAction = null;
    }

    undo() {
        if (this.pastActions.length > 0) {
            const action = this.pastActions.pop();
            this.futureActions.push(action);
            action.undo();
            this.changesMade();
            this.enableRedoButton();
            if (this.pastActions.length === 0) {
                this.disableUndoButton();
            }
        }
    }

    redo() {
        if (this.futureActions.length > 0) {
            const action = this.futureActions.pop();
            this.pastActions.push(action);
            action.redo();
            this.changesMade();
            this.enableUndoButton();
            if (this.futureActions.length === 0) {
                this.disableRedoButton();
            }
        }
    }

    new(actionName, ...args) {
        return this.current(this.factory.create(actionName, args));
    }

    execute(actionName, ...args) {
        let action = this.new(actionName, ...args);
        return action.finish();
    }

    disableUndoButton() {
        this.disableButton('undo');
    }

    enableUndoButton() {
        this.enableButton('undo');
    }

    disableRedoButton() {
        this.disableButton('redo');
    }

    enableRedoButton() {
        this.enableButton('redo');
    }

    disableButton(button) {
        window[`${button}Button`].attribute('disabled', 'true');
    }

    enableButton(button) {
        window[`${button}Button`].removeAttribute('disabled');
    }

    removeImageActions() {
        this.pastActions = this.pastActions.filter(action => !action.isImageAction);
        this.futureActions = this.futureActions.filter(action => !action.isImageAction);
        if (this.pastActions.length === 0) {
            this.disableUndoButton();
        }
        if (this.futureActions.length === 0) {
            this.disableRedoButton();
        }
    }
}
